import { render, staticRenderFns } from "./JointList.vue?vue&type=template&id=7e93ca62&scoped=true"
import script from "./JointList.vue?vue&type=script&lang=js"
export * from "./JointList.vue?vue&type=script&lang=js"
import style0 from "./JointList.vue?vue&type=style&index=0&id=7e93ca62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e93ca62",
  null
  
)

export default component.exports